import React, { useState } from "react";
import Gallery from "react-bnb-gallery";
import { Favorite } from "@/components";
import { useMemo } from "react";

/**横幅 */
export const Grid = ({ restaurant, photos, partners, loadMore, post }) => {
  const [show, setShow] = useState(false);
  const [activePhotoIndex, setActivePhotoIndex] = useState(0);
  let size = Math.min(5, photos.length);
  const photoList = photos.map((i) => {
    return {
      photo: i.picture_url.replace(/(\?+|\b)$/, "-gallery"),
    };
  });

  // 根据不同的宽度，重新渲染图片
  const ImageSizes = useMemo(() => {
    const width = partners.length ? 980 : 1190;
    const height = 254;
    const gutter = 10;
    return [
      [
        {
          width: width,
          height: height,
          left: 0,
          top: 0,
        },
      ],
      [
        {
          width: width * 0.4,
          height: height,
          left: 0,
          top: 0,
        },
        {
          width: width * 0.6 - 10,
          height: height,
          left: width * 0.4 + 10,
          top: 0,
        },
      ],
      [
        {
          width: width * 0.4,
          height: height,
          left: 0,
        },
        {
          width: width * 0.3 - gutter,
          height: height,
          left: width * 0.4 + gutter,
        },
        {
          width: width * 0.3 - gutter,
          height: height,
          left: width * 0.7 + gutter * 2,
        },
      ],
      [
        {
          width: width * 0.3,
          height: height,
          left: 0,
        },
        {
          width: width * 0.3,
          height: height,
          left: width * 0.3 + gutter,
        },
        {
          width: width * 0.4 - gutter * 2,
          height: height * 0.5,
          left: width * 0.6 + gutter * 2,
          top: 0,
        },
        {
          width: width * 0.4 - gutter * 2,
          height: height * 0.5 - gutter,
          left: width * 0.6 + gutter * 2,
          top: height * 0.5 + gutter,
        },
      ],
      [
        {
          width: width * 0.3 - gutter / 2,
          height: height,
          left: 0,
        },
        {
          width: width * 0.4 - gutter,
          height: height * 0.5 - gutter / 2,
          left: width * 0.3 + gutter / 2,
        },
        {
          width: width * 0.3 - gutter / 2,
          height: height * 0.5 - gutter / 2,
          right: 0,
          top: 0,
        },
        {
          width: width * 0.3 - gutter,
          height: height * 0.5 - gutter / 2,
          left: width * 0.3 + gutter / 2,
          top: height * 0.5 + gutter / 2,
        },
        {
          width: width * 0.4 - gutter / 2,
          height: height * 0.5 - gutter / 2,
          right: 0,
          top: height * 0.5 + gutter / 2,
        },
      ],
    ];
  }, [partners]);

  const styles = useMemo(() => {
    return ImageSizes[size - 1] || {};
  }, [ImageSizes, size]);

  const photoItems = useMemo(() => {
    return photos.length
      ? photos.slice(0, size).map((i, index) => {
          return {
            photo: i.picture_url,
            style: styles[index] || {},
          };
        })
      : [];
  }, [styles, size]);

  function showPhotos(index) {
    setActivePhotoIndex(index);
    setShow(true);
    loadMore && loadMore();
  }

  return (
    <React.Fragment>
      {photos.length ? (
        <section className="page-restaurant--grid">
          <Gallery
            onClose={() => setShow(false)}
            photos={photoList}
            activePhotoIndex={activePhotoIndex}
            show={show}
            preloadSize={2}
            showThumbnails={false}
          ></Gallery>
          <div className="photo-grid">
            {photoItems.map(({ photo, style = {} }, index) => {
              photo = `${photo}?imageView2/1/w/${Math.floor(
                style.width
              )}/h/${Math.floor(style.height)}/interlace/1`.replace("??", "?");
              return (
                <img
                  src={photo}
                  style={style}
                  key={index}
                  onClick={() => showPhotos(index)}
                />
              );
            })}
          </div>
          <Favorite restaurant={restaurant} />
          {post}
        </section>
      ) : null}
    </React.Fragment>
  );
};
